import { Heading, Icon, IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Pressable } from 'react-native';

import { VisitLegacyPage } from '../../../../components/VisitLegacyPage';
import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

interface HeaderProps {
  isMobile?: boolean;
}
export const Header = ({ isMobile }: HeaderProps) => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();

  const handleGoBack = () => {
    navigation.navigate('Cockpit');
  };

  const onProductManagementLegacyPress = () => {
    navigation.navigate({
      name: 'AngularFrame_ProductControl',
      params: { state: 'app.controleProduto.busca' },
    });
  };

  if (isMobile) {
    return (
      <VStack pt={Spacing['inset.md']} px={Spacing['inline.xxxs']} space={Spacing['inset.nano']}>
        <HStack alignItems="center" justifyContent="space-between">
          <HStack alignItems="center" space={Spacing['inline.xxs']}>
            <Pressable onPress={handleGoBack}>
              <Icon name="ArrowLeft" color={Color['brand.primary.principal']} size="xxs" />
            </Pressable>
            <Text
              testId="qa"
              variant="semibold"
              lineHeight="distant"
              fontSize={Typography['fontsize.lg']}>
              Controle de produtos
            </Text>
          </HStack>
        </HStack>
        <VisitLegacyPage onPress={onProductManagementLegacyPress} />
      </VStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" py={Spacing['inset.md']}>
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={handleGoBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Heading testId="qa" size="h2">
          Controle de produtos
        </Heading>
      </HStack>
      <VisitLegacyPage onPress={onProductManagementLegacyPress} />
    </HStack>
  );
};
